import React from 'react';
import { useT } from '../../../../i18n';

// Un invité répond sur son téléphone, les mariés reçoivent la réponse.
const RsvpVisual: React.FC = () => {
  const t = useT();
  const seg = (n: number) => (
    <span className="mk-fv-seg">
      <b className={`mk-fv-yes${n}`}>{t('Oui')}</b>
      <b>{t('Non')}</b>
    </span>
  );
  return (
    <div className="mk-fv-stage">
      <div className="mk-fv-rsvp-phone">
        <div className="mk-fv-rsvp-screen">
          <span className="mk-fv-rsvp-names">Rémi &amp; Estelle</span>
          <span className="mk-fv-rsvp-row">
            {t('Cérémonie')} {seg(1)}
          </span>
          <span className="mk-fv-rsvp-row">
            {t('Dîner')} {seg(2)}
          </span>
          <span className="mk-fv-rsvp-select">
            <span>
              {t('Poisson')} <b>▾</b>
            </span>
          </span>
          <span className="mk-fv-rsvp-send">{t('Envoyer ma réponse')}</span>
          <span className="mk-fv-rsvp-thanks">
            <i>✓</i>
            {t('Merci !')}
          </span>
        </div>
      </div>
      <div className="mk-fv-box mk-fv-rsvp-toast">
        <b>{t('Nouvelle réponse')}</b>
        <span>
          {t('Oui')} · {t('Dîner')} · {t('Poisson')}
        </span>
      </div>
    </div>
  );
};

export default RsvpVisual;
